import * as actions_service_requests from 'actions/service-requests-actions';
import * as actions_users from 'actions/users-actions';
import * as toolbox from 'components/common/toolbox';
import Badge from 'components/common/Badge';
import React, { useEffect, useState } from 'react';
import ResultsActionIcons from './results-actions/results-action-icons';
import _ from 'lodash';
import { APPS, SERVICE_REQUEST_TERMS, WORKORDERS } from 'components/constants';
import { Avatar } from 'enspire-manager-framework';
import { Button, ButtonGroup } from 'react-bootstrap';
import { DashboardDetail } from 'enspire-manager-framework';
import { Table } from 'em-table';
import { imageSize, numPanels, navMultipleUrls } from 'components/common/toolbox';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const moment = require('moment');

const ResultsMyWorkOrders = (props) => {
    
    /* Hooks --------------------------*/
    
    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
	const routeLocation = useLocation();

    const user = useSelector((store) => store.users.user);
    const employees = useSelector((store) => store.employees.employees);
    const openWorkOrders = useSelector((store) => store.workOrders.work_orders_open);

    const [filter, setFilter] = useState('today');
    const [badges, setBadges] = useState([0, 0, 0]);
    const [data, setData] = useState([]);

    const type = (params.appId == APPS.DISPATCH.id) ? 'service_request' : 'asset_request';
    const typeWorkOrders = _.filter(openWorkOrders, (wo) => wo['type'] == type);
    const orderedWorkOrders = _.orderBy(typeWorkOrders, ['_name'], ['asc']);
    
	const segments = routeLocation.pathname.split('/').length;
    const isCheckedIn = props.source == 'checkedIn';

    /* UseEffect --------------------------*/

    useEffect(() => {
        if (props.type != 'incomplete') {
            const techWorkOrders = orderedWorkOrders?.filter((workOrder) => workOrder.technicianId == user.profileId) || [];
            const typeWorkOrders = (props.type == 'active') 
                ? _.filter(techWorkOrders, (workOrder) => [WORKORDERS.PAUSED.id, WORKORDERS.ONSITE.id, WORKORDERS.ENROUTE.id, WORKORDERS.INPROGRESS.id].includes(workOrder.statusId))
                : _.filter(techWorkOrders, (workOrder) => [WORKORDERS.ASSIGNED.id].includes(workOrder.statusId))
 
            const wo_today = _.filter(typeWorkOrders, (workOrder) => moment(workOrder.startDate.seconds, 'X').startOf('day').isSame(moment().startOf('day'))).length;
            const wo_week =  _.filter(typeWorkOrders, (workOrder) => 
                moment(workOrder.startDate.seconds, 'X').startOf('day').isAfter(moment().startOf('week').subtract(1, 'day')) &&
                moment(workOrder.startDate.seconds, 'X').endOf('day').isBefore(moment().endOf('week').add(1, 'day'))
            ).length;
            const wo_all = typeWorkOrders.length;
            setBadges([ wo_today, wo_week, wo_all ]);

            if (wo_today) setFilter('today')
            else if (wo_week) setFilter('week')
            else if (wo_all) setFilter('all');
        }
    }, [openWorkOrders, user.profileId, params.appId]);

    useEffect(() => {     
        const techWorkOrders = orderedWorkOrders?.filter((workOrder) => workOrder.technicianId == user.profileId) || [];
        var work_orders = [];
        var currentEntityId = null;
        var filteredWorkOrders;

        if (props.source == 'checkedIn') {
            filteredWorkOrders = _.filter(techWorkOrders, (workOrder) => [WORKORDERS.ONSITE.id, WORKORDERS.ENROUTE.id, WORKORDERS.INPROGRESS.id].includes(workOrder.statusId));
        } else if (props.type == 'active') {
            filteredWorkOrders = _.filter(techWorkOrders, (workOrder) => [WORKORDERS.PAUSED.id, WORKORDERS.ONSITE.id, WORKORDERS.ENROUTE.id, WORKORDERS.INPROGRESS.id].includes(workOrder.statusId));
        } else if (props.type == 'incomplete') {
            filteredWorkOrders = _.filter(techWorkOrders, (workOrder) => [WORKORDERS.INCOMPLETE.id].includes(workOrder.statusId));
        } else if (props.type == 'assigned') {
            filteredWorkOrders = _.filter(techWorkOrders, (workOrder) => [WORKORDERS.ASSIGNED.id].includes(workOrder.statusId));
        }

        if (['assigned', 'active'].includes(props.type) && filter == 'today') {
            filteredWorkOrders = _.filter(filteredWorkOrders, (workOrder) => 
                moment(workOrder.startDate.seconds, 'X').startOf('day').isSame(moment().startOf('day'))
            );
        } else if (['assigned', 'active'].includes(props.type) && filter == 'week') {
            filteredWorkOrders = _.filter(filteredWorkOrders, (workOrder) =>
                (moment(workOrder.startDate.seconds, 'X').startOf('day').isAfter(moment().startOf('week')) &&
                moment(workOrder.startDate.seconds, 'X').endOf('day').isBefore(moment().endOf('week')))
            );;
        }

        filteredWorkOrders?.forEach((workOrder) => {
            
            const employee = employees?.find((o) => o.id == workOrder.technicianId);
            const entityId = (params.appId == APPS.DISPATCH.id) ? workOrder.customerId : workOrder.assetId;
            const status = _.find(Object.values(WORKORDERS), { id: workOrder.statusId });
            const technician = _.find(employees, (o) => o.id == workOrder?.technicianId);
            const name = (technician) ? technician.contact?.firstName + ' ' + technician.contact?.lastName : 'Unassigned';
            const owner = _.find(employees, (o) => o.contact?.email == workOrder?.ownerId);
            
            // Add group heading for customer or asset
            if (entityId != currentEntityId) {
                currentEntityId = entityId;
                work_orders.push({ ...workOrder,
                    status: `${(isCheckedIn) ? 'CURRENTLY CHECKED IN ' : ''} ${status?.name}`,
                    bg_color: (isCheckedIn) ? status?.color : '#aaaaaa',
                    _jsx:
                    <div className="d-flex align-items-center justify-content-between p-2" style={{ backgroundColor: '#dddddd' }}>
                        <div role="button" onClick={() => openEntity(workOrder)}>
                            <Avatar className=""
                                color="white"
                                bgColor="saddleBrown"
                                size={45}
                                fontSize={'20px'}
                                name={(params.appId == APPS.DISPATCH.id) ? workOrder._displayName : workOrder._name}
                                image={imageSize(workOrder._imageUrl, 'sm')}
                                imageWidth={60}
                                border="4px solid white"
                                role={ (workOrder._imageUrl) ? "button" : null }
                                style={{ flexShrink: 0 }}
                            />
                        </div>
                        <div className="flex-grow-1">
                            <h2 className="ml-3 m-0 text-black font-weight-normal">{
                                ((params.appId == APPS.DISPATCH.id) ? workOrder._displayName : workOrder._name) + 
                                ((workOrder._unitNumber) ? ' #' + workOrder._unitNumber : '')
                            }</h2>
                            { workOrder._address &&
                                <p className="ml-3 m-0">{ workOrder._address }</p>
                            }
                        </div>
                    </div> 
                });
            }

            work_orders.push({ ...workOrder,
                name: ((employee)
                    ? employee?.contact?.firstName + ' ' + employee?.contact?.lastName
                    : (workOrder.statusId == WORKORDERS.UNASSIGNED.id) ? 'Unassigned' : 'Unknown'),
                status: ((props.source == 'checkedIn')?'Currently ':'') + status?.name,
                _stripe_color: status?.color,
                details: <>
                    <div className="d-flex align-items-center">
                        { workOrder?.technicianId && workOrder?.technicianId != 'unassigned' &&
                            <Avatar
                                color="white"
                                bgColor="steelblue"
                                size={50}
                                fontSize={'18px'}
                                name={name}
                                image={technician?.contact.photoUrl ? imageSize(technician?.contact.photoUrl, 'sm') : null}
                                border='4px solid white'
                            />
                        }
                        <div>
                            <div className="d-flex justify-content-between">
                                <h1 className="main-heading heading-work-order align-self-start mx-2">
                                    WO #{workOrder.customId}
                                </h1>
                                <p className="mb-2 mr-auto">{ moment(workOrder.startDate?.toDate()).format('MMM Do, YYYY h:mm A') }</p>
                            </div>
                            { workOrder?.technicianId && workOrder?.technicianId != 'unassigned' &&
                                <h4 className="m-0 ml-2">{`${technician?.contact?.firstName} ${technician?.contact?.lastName}`}</h4>
                            }
                        </div>
                    </div>
                    <div className="d-flex align-items-end mb-2">
                        <div id="work-order-details" className="flex-grow-1 mt-2 mr-3">
                            <DashboardDetail field={ 'Description' } value={ workOrder.description } type="text" />
                            <DashboardDetail field={ 'Suggested' } value={ workOrder.suggested } type="text" />
                            <DashboardDetail field={ 'Created By' } value={ (owner) ? `${owner?.contact.firstName} ${owner?.contact.lastName}` : '' } type="text" />
                            { workOrder.reason &&
                                <div className="alert alert-warning mb-0 mt-2">
                                    <strong>REASON:</strong>&nbsp; { workOrder.reason }
                                </div>
                            }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <ResultsActionIcons entity={ 'workOrder' } entityId={ workOrder.id } workOrder={ workOrder } sms={ true } />
                        <button className="btn btn-default btn-lg btn-circle ml-3" onClick={ () => openWorkOrder(workOrder) }>
                            <i className="fa-duotone fa-solid fa-chevrons-right"></i>
                        </button>
                    </div>
                </>
            });
        });
        setData(work_orders);
    }, [openWorkOrders, filter, user.profileId, params.appId, routeLocation.pathname]);
    
    /* Actions ----------------------------*/

    const openWorkOrder = async (workOrder) => {
        let num = (segments >= 11) ? -2 : (segments >= 10) ? -1 : 0;
        if (num) history.go(num);

        const entityId = (params.appId == APPS.DISPATCH.id) ? workOrder.customerId : workOrder.assetId;
        const serviceRequest = await actions_service_requests.getServiceRequestById(params.handle, workOrder.serviceRequestId);
        
        if (serviceRequest.serviceRequestTermsId == SERVICE_REQUEST_TERMS.SERVICE_CALL.id) {
            navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests`, 7),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${workOrder.serviceRequestId}/work_orders/${workOrder.id}`, 10),
            ]});
        } else {
            navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests`, 7),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${workOrder.serviceRequestId}/work_orders`, 9),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${workOrder.serviceRequestId}/work_orders/${workOrder.id}/items`, 11),
            ]});
        }
    }
    const openEntity = (workOrder) => {
        const entityId = (params.appId == APPS.DISPATCH.id) ? workOrder.customerId : workOrder.assetId;
        const tab = (params.appId == APPS.DISPATCH.id) ? 'tab' : 'service_requests';

        navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
            toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/${tab}`, 7),
        ]});    
    }

    /* Constants --------------------------*/

    const columns = [
        { name: 'Details', field: 'details', type: 'jsx', width: 100 },
    ];

    const filterButtons = <ButtonGroup className="d-flex mt-3">
        <Button variant={(filter == 'today') ? 'primary' : 'default'} onClick={ () => setFilter('today') }>
            Today
            { !!badges[0] && <Badge number={badges[0]} /> }
        </Button>
        <Button variant={(filter == 'week') ? 'primary' : 'default'} onClick={ () => setFilter('week') }>
            This Week
            { !!badges[1] && <Badge number={badges[1]} /> }
        </Button>
        <Button variant={(filter == 'all') ? 'primary' : 'default'} onClick={ () => setFilter('all') }>
            All Scheduled
            { !!badges[2] && <Badge number={badges[2]} /> }
        </Button>
    </ButtonGroup> 
   
    return (
        <>
            { (!!data.length || !isCheckedIn) &&
                <>
                    { props.type != 'incomplete' && filterButtons }
                    <Table
                        data={data}
                        columns={columns}
                        active_field={'id'}
                        active_id={params.tab2_id}
                        group_by={{ fields: ['statusId'], direction: ['desc'], display: ['status'], bgColor: ['bg_color'] }}
                        hide_header={true}
                    />
                </>
            }
        </>
    );
};

export default ResultsMyWorkOrders;